import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

import App from './App.vue'
import router from './router'
import store from './store'
import './assets/common_lib/sinopsCloudWebLib.css'
// import sinopsCloudWebLib from './assets/common_lib/sinopsCloudWebLib.umd.js'
import sinopsCloudWebLib from './lib/thin_sinops_cloud_web_lib/index.js'

import awsUtils2 from './utils/aws2'

Vue.use(sinopsCloudWebLib)

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.mixin(awsUtils2)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
